<template>
  <div class="plan-item">
    <div class="plan-content">
      <h1 class="plan-header">{{ title }}</h1>
      <QS-column-box :source="source" :column="2" :list="list" separator=":" />
    </div>
    <div class="plan-action">
      <el-button type="text" @click="delItem">删除</el-button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useEditFormState } from '../../hooks/useEditFormState'

const { state: formState } = useEditFormState()

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
})
const emits = defineEmits(['delete'])

const title = computed(() => {
  const { id, name } = props.data
  return `${id}  ${name}`
})
const source = computed(() => {
  const {
    rentPeriod,
    presentDays,
    deposit,
    rentPeriodType,
    rentAmount,
    rentAmountUnit,
    otherFeeList = [],
  } = props.data

  let rentPeriodDesc = ''
  if (rentPeriodType === 1) {
    rentPeriodDesc = `${rentPeriod}天`
  } else {
    rentPeriodDesc = `${rentPeriod}个月`
  }

  return {
    cityName: formState.value?.cityName || '--',
    rentPeriodDesc: rentPeriod ? rentPeriodDesc : '--',
    presentDaysDesc: `${presentDays}天`,
    depositDesc: deposit ? `${deposit}元` : '--',
    rentAmountDesc: rentAmount ? `${rentAmount}元/${rentAmountUnit}` : '--',
    otherFeeListDesc: otherFeeList?.join('、'),
  }
})

const list = [
  {
    key: 'cityName',
    name: '城市',
  },
  {
    key: 'rentPeriodDesc',
    name: '租期',
  },
  {
    key: 'presentDaysDesc',
    name: '赠送天数',
  },
  {
    key: 'depositDesc',
    name: '押金总金额',
  },
  {
    key: 'rentAmountDesc',
    name: '租金',
    alone: true,
  },
  {
    key: 'otherFeeListDesc',
    name: '其他费项',
    alone: true,
  },
]
const delItem = () => {
  emits('delete', props.index)
}
</script>

<style lang="scss" scoped>
.plan-item {
  border-radius: 8px;
  opacity: 1;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #e7e8eb;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ::v-deep {
    .el-column-box__title {
      color: rgba(0, 0, 0, 0.6);
    }
  }
  .plan-action {
    display: flex;
    align-items: center;
    margin-left: auto;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    text-align: justify;
    letter-spacing: 0em;
    color: #366cfe;
    padding-left: 16px;
  }

  .plan-content {
    flex: 1;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: calc(100% - 12px);
      background-color: #ebeef5;
    }
    > h1.plan-header {
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 500;
      padding: 0;
      margin: 0;
      margin-bottom: 8px;
      line-height: 22px;
      text-align: justify;
      letter-spacing: 0em;
      color: rgba(0, 0, 0, 0.9);
    }
    .info-item {
      display: flex;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }

      > span:first-child {
        color: #909399;
        margin-right: 8px;
      }
    }
    ::v-deep {
      .el-column-box > div {
        margin-bottom: 4px !important;
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: normal;
        line-height: 22px;
        text-align: justify;
        letter-spacing: 0em;
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }
}
</style>
